export const documentExtractDocumentationMarkdown = `
# Document Extract

The Document Extract block retrieves and processes patient documents from the EHR based on specified criteria.

## Input

- **Patient Source**: A reference to the patient block providing patient information.

## Configuration

- **Title Filters**: An array of strings to filter documents by title (optional).
- **Type Filters**: An array of strings to filter documents by type (optional).
- **Document Limit**: The maximum number of documents to retrieve (1-100).
- **Lookback Duration**: The time period to search for documents, consisting of:
  - **Value**: A positive integer.
  - **Unit**: One of the following: "Days", "Weeks", "Months", or "Years".

## Process

1. Retrieves document metadata from the FHIR service within the specified lookback period.
2. Applies title and type filters to the metadata.
3. Downloads document binaries for the filtered metadata.
4. Saves the PDF files to a Google Cloud Storage bucket.

## Output

Returns a list of document metadatas for the downloaded documents along
with the path to the cloud storage link for each document downloaded

This output can be used by subsequent blocks for OCR, care gap analysis, or HCC algorithm processing, etc.
`;
